import { Platform } from 'react-native';
import { useIsMobileBrowser } from './useIsMobileBrowser';

/** True only on a desktop-width web browser — the one environment where
 * ScreenLayout actually renders LeftPane/RightPane at all. Shared by
 * AppNavigator (to decide whether to route a screen through
 * PersistentPaneShell) and by each of that shell's screens (to decide
 * whether to return bare content for the shell or wrap themselves in their
 * own <ScreenLayout>, for native/narrow-mobile-web). Both sides MUST use
 * this same reactive hook — previously this was computed independently in
 * several places, including one (InboxScreen's own isMobileBrowser) that
 * read a non-reactive module-scope Dimensions.get() snapshot. If the two
 * sides ever disagreed (e.g. resizing across the breakpoint without a
 * reload), AppNavigator could route a screen through the persistent shell
 * while the screen itself still rendered its own <ScreenLayout> too,
 * producing a ScreenLayout-inside-ScreenLayout double chrome bug. */
export function useDesktopPaneLayout(): boolean {
  return Platform.OS === 'web' && !useIsMobileBrowser();
}
